import React from "react";
import "./styles/index.css";

export default function App() {
  return <h1>Coming soon! :)</h1>;
}
